import Vue from 'vue'
import VueRouter from 'vue-router'
import Garden from '../views/Garden.vue'
import Explore from '../views/Explore.vue'
import Profile from '../views/Profile.vue'
import Activity from '../views/Activity.vue'
import Plant from '../views/Plant.vue'
import About from '../views/About.vue'
import TermsAndPrivacyPolicy from '../views/TermsAndPrivacyPolicy.vue'
import Ideas from '../views/Ideas.vue'
import SignIn from "../views/SignIn.vue";

Vue.use(VueRouter)

const routes = [
  {
    path:"*",
    redirect:"/"
  },
  {
    path: '/terms-and-privacy-policy',
    name: 'TermsAndPrivacyPolicy',
    component: TermsAndPrivacyPolicy
  },
  {
    path: '/sign-in',
    name: 'SignIn',
    component: SignIn
  },
  {
    path: '/profile',
    name: 'Profile',
    component: Profile
  },
  {
    path: '/',
    name: 'Activity',
    component: Activity
  },
  {
    path: '/ideas',
    name: 'Ideas',
    component: Ideas
  },
  {
    path: '/garden/:gardenId',
    name: 'Garden',
    component: Garden
  },
  {
    path: '/garden/:gardenId/plant/:plantId',
    name: 'Plant',
    component: Plant
  },
  {
    path: '/explore/:gardenId',
    name: 'Explore',
    component: Explore,
    // children: [
    //   {
    //     path: '/garden/:gardenId',
    //     name: 'Explore Garden',
    //     component: Explore
    //   }
    // ]
  },
  {
    path: '/about',
    name: 'About',
    component: About
  },
  {
    path: '/update',
    name: 'Update',
    component: () => import(/* webpackChunkName: "update" */ '../views/Update.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

export default router
